document.querySelectorAll('.filter-section__toggle').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const section = toggle.closest('.filter-section');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute('aria-expanded', String(!expanded));
    section.classList.toggle('is-open', !expanded);
  });
});

const toggleBtn = document.getElementById('toggle-filters-btn');
const sidebar = document.querySelector('.archive-products__sidebar');
if (toggleBtn && sidebar) {
  toggleBtn.addEventListener('click', () => {
    sidebar.classList.toggle('is-visible');
    const isActive = sidebar.classList.contains('is-visible');
    toggleBtn.classList.toggle('is-active', isActive);
  });
}

const brandForm = document.getElementById('brand-filter-form');
if (brandForm) {
  brandForm.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const label = checkbox.closest('.filter-checkbox');
      if (label) label.classList.toggle('is-checked', checkbox.checked);
      brandForm.submit();
    });
  });
}

